import { enumOptions } from '@utils/enumOptions';

export const taskStatus = {
  OPEN: 'OPEN',
  DONE: 'DONE',
};

export const taskStatusInt = {
  [taskStatus.OPEN]: 1,
  [taskStatus.DONE]: 2,
};

export const taskStatusLabels = {
  [taskStatus.OPEN]: 'Open',
  [taskStatus.DONE]: 'Done',
};

export const taskStatusOptions = enumOptions(taskStatusLabels);
export const taskStatusOptionsInt = enumOptions(taskStatusLabels, taskStatusInt);
